import {Component} from "react";

export default class ResultTable extends Component {

}